

























import {Vue, Component} from "vue-property-decorator";
import axios from "axios";
import Footer from "@/component/footer.vue";
import MailResend from "@/component/mail-resend.vue";
import {Message} from "@/message";
import {AxiosUtils} from "@/axios-utils";
import {CommonConstant} from "@/common-constant";

@Component({
    components: {Footer, MailResend}
})

export default class MailConfirmWaiting extends Vue {
    /** 共通ID表示名 */
    commonIdName: string = CommonConstant.COMMON_ID_NAME;

    showMailResendDialog: boolean = false;

    /** メール再送のエラーメッセージ */
    errorMessage: string = "";

    /** authのタイマー */
    startAuthTimer = null;

    /** /auth APIをタイマー実行します。戻り値はタイマーです。 */
    startAuth() {
        // セッションから「リダイレクトURL（メール検証後コールバック）」を取得する
        let redirectUriForMail = sessionStorage.getItem("redirectUrlForMail");
        let param = (redirectUriForMail) ? `?redirect_uri=${encodeURIComponent(redirectUriForMail)}` : "";
        return setTimeout(() => {
            axios.get(`/auth${param}`)
                .then(() => {
                    // One-ID認証済みの場合
                    if (redirectUriForMail) {
                        // 「リダイレクトURL（メール検証後コールバック）」が指定されている場合、指定URLへリダイレクト
                        sessionStorage.removeItem("redirectUrlForMail"); // 遷移時にはセッションから削除
                        window.location.href = redirectUriForMail;
                    } else {
                        // 上記以外の場合、MyPageに遷移
                        this.$router.push("/client/mypage");
                    }
                })
                .catch(error => {
                    // HTTPステータスコードが「401（未認証）」、且つ、戻り先URL（Auth0）が指定されている場合
                    if (AxiosUtils.isUnauthorized(error)) {
                        // 「リダイレクトURL（メール検証後コールバック）」が存在、且つ、ホワイトリストチェックがOKなら、セッションに登録する
                        // ※ callback.vueで参照
                        if (redirectUriForMail) sessionStorage.setItem("redirectUrlForMail", redirectUriForMail);

                        // ログイン画面にリダイレクト
                        window.location.href = error.response.data.replace("redirect: ", "");
                        return;
                    }
                    AxiosUtils.gotoClientErrorPage(error, this.$router)
                });
        }, 3000);
    }

    created() {
        this.startAuthTimer = this.startAuth();
    }

    showResendMailDialog() {
        // authタイマーを停止する
        clearTimeout(this.startAuthTimer);
        // ダイアログ表示
        this.showMailResendDialog = true;
    }

    closeResendMailDialog(status: number, data: string) {
        // ダイアログを非表示にする
        this.showMailResendDialog = false;

        if (status) {
            if (status == 200 || status == 400) {
                // 正常、チェックエラーの場合
                // メッセージを表示
                if (data) {
                    this.errorMessage = Message[data];
                } else {
                    this.errorMessage = "";
                }
                // タイマーを再度実行する
                this.startAuthTimer = this.startAuth();
            } else {
                // 上記以外の場合、エラー画面に遷移
                this.$router.push("/client/error");
            }
        } else {
            // ×ボタンで閉じられた場合、タイマーを再度実行する
            this.startAuthTimer = this.startAuth();
        }
    }

    registerOtherMail() {
        axios.get("/email/register-other")
            .then(cb => {
                if (cb.data) {
                    window.location.href = cb.data.toString();
                } else {
                    // URLが指定されていない場合、エラー画面へ遷移
                    this.$router.push("/client/error");
                }
            })
            .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
    }
}
